
import React from "react";
import PropTypes from "prop-types";
import RoomIcon from "@mui/icons-material/Room";

function JobOverview(props) {
  const { job, onJobApplied, userType } = props;
  const patternRegex = new RegExp("[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}");
  if (Object.keys(job).length === 0) {
    return;
  }
  return (
    <div className="JobOverview-container rounded-xl bg-white px-6 py-16 flex flex-col h-full overflow-y-auto">
      <div className="JobOverview-type text-base mb-3 font-brand-primary flex">
        <div className="JobOverview-detailsTitle text-base mr-1 font-brand-primary">
          {Array.isArray(job.jobLevel) ? job.jobLevel.join(" ") : job.jobLevel}
        </div>
        •
        <div className="JobOverview-detailsTitle text-base mx-1 font-brand-primary">
          {Array.isArray(job.jobType) ? job.jobType.join(" ") : job.jobType}
        </div>
        •
        <div className="JobOverview-detailsTitle text-base ml-1 font-brand-primary">
          {Array.isArray(job.jobIndustry) ?
            job.jobIndustry.join(" ") :
            job.jobIndustry}
        </div>
      </div>
      <div className="JobOverview-title text-4xl font-bold mb-4  font-brand-primary flex">
        {job.title}
      </div>
      <div className="JobOverview-location text-base mb-3  font-brand-primary flex justify-start py-auto">
        <RoomIcon fontSize="medium" className="flex my-auto mr-1" />
        {job.location}
      </div>
      <div className="JobOverview-company text-base mb-3 font-brand-primary flex">
          {job.company}
      </div>
        <div className="JobOverview-company text-base mb-3 font-brand-primary flex">
          <span style={{ fontWeight: "bold" }}>Company Link: </span> &nbsp;
          <a href={job.companyLink.startsWith("http://") || job.companyLink.startsWith("https://")
            ? job.companyLink
            : `http://${job.companyLink}`} target="_blank" rel="noreferrer"
            style={{ color: "#0000EE", cursor: "pointer", background: "none", border: "none", padding: 0, textDecoration: "underline" }}
            onMouseOver={(e) => e.currentTarget.style.color = "#551A8B"}
            onMouseOut={(e) => e.currentTarget.style.color = "#0000EE"}>
            {job.companyLink.startsWith("http://") || job.companyLink.startsWith("https://")
              ? job.companyLink
              : `http://${job.companyLink}`}
          </a>
        </div>
      <a
        href={
          patternRegex.test(job.link) 
          ? "mailto:" + job.link 
          : (job.link.startsWith("http://") || job.link.startsWith("https://") 
             ? job.link 
             : `http://${job.link}`)
        }
        target="_blank"
        onClick={() => onJobApplied(job)}
        rel="noreferrer"
        className="primary-button bg-brand-primary w-fit"
      >
        Apply
      </a>
      <div className="JobOverview-detailsContainer">
        <div className="JobOverview-detailsTitle text-xl font-bold mb-2 font-brand-primary">
          Job Details
        </div>
        <div className="JobOverview-detailsDescription text-base mb-3 flex font-brand-primary">
          {job.details}
        </div>
      </div>
      <div className="JobOverview-infoContainer flex pr-80 justify-between">
        <div className="JobOverview-applyContainer">
          <div className="JobOverview-applyTitle text-xl font-bold mb-2 font-brand-primary">
            How to Apply:
          </div>
          <div className="JobOverview-applyDescription text-base mb-3 flex font-brand-primary">
            {job.applyDetails}
          </div>
        </div>
        <div className="JobOverview-postedContainer">
          <div className="JobOverview-postedTitle text-xl font-bold mb-2 font-brand-primary">
            {userType === "admin" || userType === "company" ? "Posting Start:" : "Date Posted:"}
          </div>
          <div className="JobOverview-postedDescription text-base mb-3 flex font-brand-primary">
            {job.startDate}
          </div>
        </div>
        <div className="JobOverview-dueDateContainer">
          <div className="JobOverview-postedTitle text-xl font-bold mb-2 font-brand-primary">
            {userType === "admin" || userType === "company" ? "Posting End:" : "Application Deadline:"}
          </div>
          <div className="JobOverview-dueDateDescription text-base mb-3 flex font-brand-primary">
            {job.endDate}
          </div>
        </div>
      </div>
      <div className="JobOverview-skillsContainer">
        {(job.skills.length > 0) && <div className="JobOverview-skillsTitle text-xl font-bold mb-2 font-brand-primary">
          Skills
        </div>}
        <div className="JobOverview-skillsDescription text-base mb-3 flex font-brand-primary">
          {Array.isArray(job.skills) ? job.skills.join(", ") : job.skills}
        </div>
      </div>
    </div>
  );
}

JobOverview.propTypes = {
  job: PropTypes.shape({
    title: PropTypes.string,
    location: PropTypes.string,
    company: PropTypes.string,
    details: PropTypes.string,
    link: PropTypes.string,
    companyLink: PropTypes.string,
    applyDetails: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    jobType: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
    viewCount: PropTypes.number,
    applyCount: PropTypes.number,
    favorited: PropTypes.string,
  }),
  onJobApplied: PropTypes.func,
  userType: PropTypes.string,
};

JobOverview.defaultProps = {
  job: {},
  onJobApplied: () => { },
};

export default JobOverview;
